import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useSwaggerClient } from '../../hooks/useSwaggerClient';

const useStyles = makeStyles({
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
    }
});

const PriceRuleAutoComplete = ({ type, value, setValue, fullWidth, label = '' }) => {
    const styles = useStyles();

    // Ensure value is always an array - handle old format (string) and new format (array)
    const safeValue = Array.isArray(value)
        ? value
        : typeof value === 'string' && value.length > 0
        ? [value]
        : [];

    // Conditionally fetch data based on type
    const [islands, loadingIslands, errorIslands] = useSwaggerClient(
        type === 'island' ? 'islands' : false,
        type === 'island' ? 'getAllIslands' : false,
        { page: 0, pageSize: 100, search: '' }
    );

    const [tags, loadingTags, errorTags] = useSwaggerClient(
        type === 'tag' ? 'clients' : false,
        type === 'tag' ? 'getClientTags' : false
    );

    const isLoading = type === 'island' ? loadingIslands : loadingTags;
    const error = type === 'island' ? errorIslands : errorTags;

    if (isLoading) {
        return (
            <div className={styles.container}>
                <CircularProgress size="1.5rem" />
            </div>
        );
    }

    if (error) {
        return (
            <div className={styles.container}>
                <p>{`Error fetching ${type === 'island' ? 'islands' : 'tags'}`}</p>
            </div>
        );
    }

    const islandNames =
        type === 'island' && islands?.islands ? islands.islands.map(e => e.name) : [];

    return (
        <Autocomplete
            multiple
            freeSolo
            options={type === 'island' ? islandNames : tags}
            value={safeValue}
            onChange={(_, newValue) => setValue(newValue)}
            renderInput={params => (
                <TextField
                    {...params}
                    variant="standard"
                    label={label}
                    placeholder="Press enter to add new"
                    fullWidth={fullWidth}
                    style={{ minWidth: '200px' }}
                />
            )}
        />
    );
};

export default PriceRuleAutoComplete;
